module.exports = __webpack_public_path__ + "img/banner.e97a6a25.png";